/**
 * Created by CCristi on 4/04/17.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MissingIdentityImplementationException = undefined;

var _Exception2 = require('./Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let MissingIdentityImplementationException = exports.MissingIdentityImplementationException = function (_Exception) {
  _inherits(MissingIdentityImplementationException, _Exception);

  /**
   * @param {String} providerName
   */
  function MissingIdentityImplementationException(providerName) {
    _classCallCheck(this, MissingIdentityImplementationException);

    return _possibleConstructorReturn(this, (MissingIdentityImplementationException.__proto__ || Object.getPrototypeOf(MissingIdentityImplementationException)).call(this, `Missing identity implementation for "${providerName}"`));
  }

  return MissingIdentityImplementationException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-security/lib.compiled/Exception/MissingIdentityImplementationException.js
// module id = 440
// module chunks = 0